import styles from './style.postcss';

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { PageCard, StudentCard, testClass } from 'omni-common-ui';
import { parseProductionStatus } from 'domain/ProductionStatus';
import ProgressReportStatus from 'components/ProgressReportStatus';
import StudentCardProfile from 'containers/StudentCardProfile';

export const ReportStudentCard = (props) => {
  const { studentGeneralInfo, member, reportStatus, submittedDate } = props;
  const status = parseProductionStatus(member.status);
  const pageCardClassName = classnames(styles.ReportStudentCard,
    testClass('report-student-card'));
  return <PageCard className={pageCardClassName}>
    <PageCard.Heading text="Student" />
    <PageCard.Content className={styles.ReportStudentCard_content}>
      <div className={classnames(styles.ReportStudentCard_content_items,
          styles.ReportStudentCard_studentInfo)}>
        <StudentCard borderless backgroundless>
          <StudentCardProfile useLowerLevelPersonComponent
              className={styles.ReportStudentCard_profile}
              withoutBottomPadding
              studentId={studentGeneralInfo.id}
              status={status.fullName}
              statusHighlighted={member.isInProduction} />
        </StudentCard>
      </div>
      <div className={classnames(styles.ReportStudentCard_items,
          styles.ReportStudentCard_reportStatus)}>
        <h2 className={styles.ReportStudentCard_reportStatus_title}>
          Report Status
        </h2>
        <ProgressReportStatus status={reportStatus}
            className={styles.ReportStudentCard_reportStatus_status} />
      </div>
      <div className={classnames(styles.ReportStudentCard_items,
          styles.ReportStudentCard_reportStatus)}>
        <h2 className={styles.ReportStudentCard_reportStatus_title}>
          Submitted Date
        </h2>
        <p className={styles.ReportStudentCard_reportStatus_status}>{submittedDate}</p>
      </div>
    </PageCard.Content>
  </PageCard>;
};

ReportStudentCard.propTypes = {
  studentName: PropTypes.string,
  studentGeneralInfo: PropTypes.object,
  member: PropTypes.object,
  reportStatus: PropTypes.string,
  submittedDate: PropTypes.string,
};

export default ReportStudentCard;



// WEBPACK FOOTER //
// ./containers/Group/ProgressReport/StudentReportView/ReportStudentCard/index.jsx